import { ApiType } from "@gymflow/common";
import { zonedTimeToUtc } from "@gymflow/helpers";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { reportQueryKeys } from "../report";
import { leadQueryKeys } from "./leadQueryKeys";

export function useMutationLeadBulkStatusUpdateFilter({
  api,
  tz,
}: {
  api: ApiType;
  tz: string;
}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      payload: Parameters<ApiType["leadApi"]["bulkStatusUpdateFilter"]>[0],
    ) => {
      const parsedOpts = { ...payload };
      if (payload?.createdFrom) {
        parsedOpts.createdFrom = zonedTimeToUtc(payload.createdFrom, tz);
      }
      if (payload?.createdTo) {
        parsedOpts.createdTo = zonedTimeToUtc(payload.createdTo, tz);
      }
      return await api.leadApi.bulkStatusUpdateFilter(parsedOpts);
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: leadQueryKeys.all() });
      queryClient.invalidateQueries({ queryKey: reportQueryKeys.lead() });
    },
  });
}
